import * as React from 'react';
import PaymentsSubscription from '../../modules/PaymentSubscription/components/SubscriptionWrapper';

interface Props {
  totalPayments: number;
  totalSum: number;
}

const PaymentsInfoTotal = (props: Props) => {

  return (
    <div className='d-flex justify-between payments-total-head'>
      <div className='d-flex flex-column align-center justify-evenly payments-head-container'>
        <div className='payments-head'>
          {'Total payments for selected period:'}
        </div>
        <div className='payments-head-text'>
          {props.totalPayments}
        </div>
      </div>
      <div className='d-flex flex-column align-center justify-evenly payments-head-container'>
        <div className='payments-head'>
          {'Total sum for selected period:'}
        </div>
        <div className='payments-head-text'>
          {'$' + props.totalSum.toFixed(2)}
        </div>
      </div>
      <div className='d-flex flex-column align-center justify-evenly payments-head-container'>
        <div className='payments-head'>
          {'Subscription:'}
        </div>
        <PaymentsSubscription />
      </div>
    </div>
  );
};

export default PaymentsInfoTotal;
